import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  deleteExpedientFollow,
  getExpedientFollow,
  getFollowedExpedientsSummary,
  postExpedientSeen,
  putExpedientFollow,
} from 'services/api/endpoints/gdp/expedients';
import { ExpedientFollowState, FollowedSummary } from './constants';

const itemOrThrow = (response: any) => {
  if (!response?.data?.success) throw new Error(response?.data?.message ?? 'expedient follow request failed');
  return response.data.item;
};

/** Seguidos y cuántos tienen novedades: lo pide el menú al entrar y cada minuto. */
export const getFollowedSummaryAsync: any = createAsyncThunk('expedientFollow/getSummary', async () => {
  return (itemOrThrow(await getFollowedExpedientsSummary()) ?? { total: 0, unread: 0, items: [] }) as FollowedSummary;
});

export const getExpedientFollowAsync: any = createAsyncThunk('expedientFollow/getState', async (expedientId: string) => {
  return { expedientId, state: itemOrThrow(await getExpedientFollow(expedientId)) as ExpedientFollowState };
});

export const followExpedientAsync: any = createAsyncThunk('expedientFollow/follow', async (expedientId: string, { dispatch }) => {
  itemOrThrow(await putExpedientFollow(expedientId));
  dispatch(getFollowedSummaryAsync());
  return { expedientId, state: itemOrThrow(await getExpedientFollow(expedientId)) as ExpedientFollowState };
});

export const unfollowExpedientAsync: any = createAsyncThunk('expedientFollow/unfollow', async (expedientId: string, { dispatch }) => {
  itemOrThrow(await deleteExpedientFollow(expedientId));
  dispatch(getFollowedSummaryAsync());
  return { expedientId, state: itemOrThrow(await getExpedientFollow(expedientId)) as ExpedientFollowState };
});

/**
 * Abrir el expediente lo marca visto (si no se sigue, el back no hace nada). Se repide el resumen después: uno
 * que ya estuviera en vuelo podría devolver el punto que el visto acaba de quitar.
 */
export const markExpedientSeenAsync: any = createAsyncThunk('expedientFollow/markSeen', async (expedientId: string, { dispatch }) => {
  itemOrThrow(await postExpedientSeen(expedientId));
  dispatch(getFollowedSummaryAsync());
  return expedientId;
});
